var PosData = require("./../../abstract/posData.js");
var lib_core = require("lib-core");

var SchematicDotData = function(pos){
    this.makeObservableTreeNode();
    this.addPos(pos);
};
lib_core.mixin(SchematicDotData, lib_core.ObservableTreeNode, PosData);
lib_core.JsonParser.registerClass(SchematicDotData, "Dot");

module.exports = SchematicDotData;
